import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const VARIANTS = {
  success: {
    border: 'border-success/30',
    icon: 'CheckCircle2',
    iconColor: 'var(--color-success)',
    text: 'text-success',
  },
  error: {
    border: 'border-destructive/30',
    icon: 'AlertCircle',
    iconColor: 'var(--color-destructive)',
    text: 'text-destructive',
  },
};

const FixedToast = ({
  isOpen,
  message,
  variant = 'success',
  onClose,
}) => {
  const { t } = useTranslation();
  if (!isOpen || !message || typeof document === 'undefined') return null;

  const styles = VARIANTS[variant] ?? VARIANTS.success;

  return createPortal(
    <div className="fixed top-4 right-4 z-[200] w-[calc(100%-2rem)] max-w-sm pointer-events-none">
      <div
        className={cn(
          'pointer-events-auto bg-card rounded-lg border shadow-elevation-lg p-4 flex items-start gap-3',
          styles.border,
        )}
        role="status"
        aria-live="polite"
      >
        <Icon name={styles.icon} size={20} color={styles.iconColor} className="flex-shrink-0 mt-0.5" />
        <p className={cn('text-sm font-medium flex-1', styles.text)}>{message}</p>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
            aria-label={t('common.dismiss')}
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </div>
    </div>,
    document.body,
  );
};

export default FixedToast;
